

































































































































































import { Component, Vue, Inject, Watch} from 'vue-property-decorator'
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import CountReportTab from './countReportTab.vue'
import Bar from '../../../components/echarts/bar.vue'
import BarLine from '../../../components/echarts/barLine.vue'
@Component({
    name:'projectCount',
    components:{
        CountReportTab,
        Bar,
        BarLine
    },
    filters:{
        percentage(num:any){
            if(num >= 1){
                return num.toFixed(2) + "%";
            }
            return  (num*100).toFixed(2) + "%";
        }
    }
})
export default class projectCount extends AbpBase  {
    initData:any = {
        searchOneForm:{
            beginYear:null,
            endYear:null,
            belongDepId:null,
            secondBelongDepId:null
        },
        searchTwoForm:{
            beginYear:null,
            endYear:null,
            belongDepId:null,
            secondBelongDepId:null
        },
        searchThreeForm:{
            projectLeaderId:null,
            belongDepId:null,
            secondBelongDepId:null
        },
        searchFourForm:{
            beginYear:null,
            endYear:null,
            belongDepId:null,
            secondBelongDepId:null
        },
        searchFiveForm:{
            beginYear:null,
            endYear:null,
            belongDepId:null,
            secondBelongDepId:null
        },
        dataTabelOne:{},
        dataTabelTwo:[],
        dataTabelThree:[],
        columnTabelTwo:[
            {
                title: '行数',
                key: '',
                render:(h:any,params:any) => {
                    return h('span',{},params.index + 1)
                }
            },
            {
                title: '项目负责人',
                key: 'leader'
            },
            {
                title: '项目总金费（元）',
                key: 'projectAmountTotalFormat',
                render:(h:any,params:any) => {
                    return h('span',{},params.row.item.projectAmountTotalFormat)
                }
            },
            {
                title: '已收款金额（元）',
                key: 'receivedAmountTotalFormat',
                render:(h:any,params:any) => {
                    return h('span',{},params.row.item.receivedAmountTotalFormat)
                }
            },
            {
                title: '未收款金额（元）',
                key: 'unReceivedAmountTotalFormat',
                render:(h:any,params:any) => {
                    return h('span',{},params.row.item.unReceivedAmountTotalFormat)
                }
            },
            {
                title: '开票未收款金额（元）',
                key: 'ticketUnReceiveAmountTotalFormat',
                render:(h:any,params:any) => {
                    return h('span',{},params.row.item.ticketUnReceiveAmountTotalFormat)
                }
            },
            {
                title: '利润（元）',
                key: 'profitAmountFormat',
                render:(h:any,params:any) => {
                    return h('span',{},params.row.item.profitAmountFormat)
                }
            },
            
        ],
        orgs:[],//部门
        leaders:[],//项目负责人
        secondBelong:[],//二级部门
        secondOneBelong: [], // 二级部门
        secondFiveBelong: [], // 二级部门
        secondThreeBelong:[], // 二级部门
        secondFourBelong:[], // 二级部门
        statisticCAndPBySecondDepAsyncData:{
            name:[],
            projectAmountTotal:[],//项目总经费
            receivedAmountTotal:[],//已收款金额
            unReceivedAmountTotal:[],//未收款金额
            ticketUnReceiveAmountTotal:[],//开票未收款金额
            profitAmount:[],//利润
        },//二级部门统计数据
        statisticCAndPByYearData:{
            name:[],
            projectCount:[],
            projectAmountTotal:[],
            receivedAmountTotal:[],
            unReceivedAmountTotal:[],
            ticketUnReceiveAmountTotal:[],
            profitAmount:[]
        },//整体统计数据
        isShowOne:true,
        isShowTwo:true,
        isShowThree:true
    }
    //获取部门
    async GetBearOrganization(){
        this.initData.orgs = (await Ajax.get('/api/services/app/Organization/GetBearOrganization')).data.result;
        this.initData.secondOneBelong = (await Ajax.get('/api/services/app/Organization/GetAllChildrenOrganizationByParentIdAsync?id='+this.initData.searchOneForm.belongDepId)).data.result;
        this.initData.secondFiveBelong = this.initData.secondOneBelong;
        this.initData.secondThreeBelong = this.initData.secondOneBelong;
        this.initData.secondFourBelong = this.initData.secondOneBelong;
    }
    //获取二级部门
    async getSecondBelong(res:any,type:any){
        (this['$refs']['belong'] as any).clearSingleSelect();//重置
        // this.initData.secondBelong = (await Ajax.get('/api/services/app/Organization/GetAllChildrenOrganizationByParentIdAsync?id='+res)).data.result;
        await Ajax.get('/api/services/app/Organization/GetAllChildrenOrganizationByParentIdAsync?id='+res)
                  .then( (res: any) => {
                      if(type == 'one'){
                          this.initData.secondOneBelong = res.data.result;
                      } else if(type == 'five') {
                          this.initData.secondFiveBelong = res.data.result;
                      } else if(type == 'three'){
                          this.initData.secondThreeBelong = res.data.result;
                      } else if(type == 'four') {
                          this.initData.secondFourBelong = res.data.result;
                      }
                 } )
    }
    //获取所有项目负责人
    async GetAllProjectLeaderAsync(){
        this.initData.leaders = (await Ajax.get('/api/services/app/User/GetAllProjectLeaderAsync'));
    }
    async GetDataTabelOne(data:any){
        this.initData.dataTabelOne = (await Ajax.post('/api/services/app/Statistic/StatisticCAndPBaseDataAsync',data)).data.result;
    }
    //获取二级部门数据
    async GetStatisticCAndPBySecondDepAsync(data:any){
        await Ajax.post('/api/services/app/Statistic/StatisticCAndPBySecondDepAsync',data).then( (res:any)=>{
            for( let key in  this.initData.statisticCAndPBySecondDepAsyncData){
                this.initData.statisticCAndPBySecondDepAsyncData[key] = [];
            }
            res.data.result.forEach((item:any) => {
                this.initData.statisticCAndPBySecondDepAsyncData.name.push(item.secondDep)
                this.initData.statisticCAndPBySecondDepAsyncData.projectAmountTotal.push(item['item']['projectAmountTotal']);
                this.initData.statisticCAndPBySecondDepAsyncData.receivedAmountTotal.push(item['item']['receivedAmountTotal']);
                this.initData.statisticCAndPBySecondDepAsyncData.unReceivedAmountTotal.push(item['item']['unReceivedAmountTotal']);
                this.initData.statisticCAndPBySecondDepAsyncData.ticketUnReceiveAmountTotal.push(item['item']['ticketUnReceiveAmountTotal']);
                this.initData.statisticCAndPBySecondDepAsyncData.profitAmount.push(item['item']['profitAmount']);
            });
        } )
    }
    //获取历年整体数据
    async GetStatisticCAndPByYearAsync(data:any){
        await Ajax.post('/api/services/app/Statistic/StatisticCAndPByYearAsync',data).then( (res:any)=>{
            for( let key in  this.initData.statisticCAndPByYearData){
                this.initData.statisticCAndPByYearData[key] = [];
            }
            res.data.result.forEach( (item:any) => {
                this.initData.statisticCAndPByYearData.name.push(item.year);
                this.initData.statisticCAndPByYearData.projectCount.push(item.item.projectCount);
                this.initData.statisticCAndPByYearData.projectAmountTotal.push(item.item.projectAmountTotal);
                this.initData.statisticCAndPByYearData.receivedAmountTotal.push(item.item.receivedAmountTotal);
                this.initData.statisticCAndPByYearData.unReceivedAmountTotal.push(item.item.unReceivedAmountTotal);
                this.initData.statisticCAndPByYearData.ticketUnReceiveAmountTotal.push(item.item.ticketUnReceiveAmountTotal);
                this.initData.statisticCAndPByYearData.profitAmount.push(item.item.profitAmount);
            } )
        } )
    }
    //获取项目负责人情况
    async GetStatisticCAndPByProjectLeader(data:any){
        await Ajax.post('/api/services/app/Statistic/StatisticCAndPByProjectLeaderAsync',data).then( (res) => {
            this.initData.dataTabelTwo = res.data.result;
        } )
    }
    //获取收款负责人情况
    async GetStatisticCAndPByReceiptLeader(data:any){
        await Ajax.post('/api/services/app/Statistic/StatisticCAndPByReceiptLeaderAsync',data).then( (res) => {
            this.initData.dataTabelThree = res.data.result;
        } )
    }
    //切换
    switchTab(data:any){
        if(data == 'one'){
            this.initData.isShowOne = !this.initData.isShowOne;
        }else if(data == 'two'){
            this.initData.isShowTwo = !this.initData.isShowTwo;
        }else if(data == "three"){
            this.initData.isShowThree = !this.initData.isShowThree;
        }
    }
    async mounted(){
        await this.GetAllProjectLeaderAsync();
        this.initData.searchOneForm.belongDepId = this.$store.state.session.user.organization.id;
        this.initData.searchTwoForm.belongDepId = this.$store.state.session.user.organization.id;
        this.initData.searchThreeForm.belongDepId = this.$store.state.session.user.organization.id;
        this.initData.searchFourForm.belongDepId = this.$store.state.session.user.organization.id;
        this.initData.searchFiveForm.belongDepId = this.$store.state.session.user.organization.id;
        await this.GetBearOrganization();
        // this.GetDataTabelOne(this.initData.searchOneForm);
        // this.GetStatisticCAndPBySecondDepAsync(this.initData.searchTwoForm)
        // this.GetStatisticCAndPByYearAsync(this.initData.searchThreeForm)
        // this.GetStatisticCAndPByProjectLeader(this.initData.searchFourForm);
        // this.GetStatisticCAndPByReceiptLeader(this.initData.searchFiveForm);
    }
    @Watch('initData.searchOneForm',{deep: true})  //基础数据
    async WatchSearchOne(newVal:any,oldValue:any){
        this.initData.searchNewOneForm = Object.assign({},newVal);
        this.initData.searchNewOneForm.beginYear = new Date(this.initData.searchNewOneForm.beginYear).getFullYear();
        this.initData.searchNewOneForm.endYear = new Date(this.initData.searchNewOneForm.endYear).getFullYear();
        if(newVal.belongDepId != null){
            await this.GetDataTabelOne(this.initData.searchNewOneForm);
        } 
    }
    @Watch('initData.searchTwoForm',{deep: true})  //二级部门数据
    async WatchSearchTwo(newVal:any,oldValue:any){
        this.initData.searchNewTwoForm = Object.assign({},newVal);
        this.initData.searchNewTwoForm.beginYear = new Date(this.initData.searchNewTwoForm.beginYear).getFullYear();
        this.initData.searchNewTwoForm.endYear = new Date(this.initData.searchNewTwoForm.endYear).getFullYear();
        if(newVal.belongDepId != null){
            await this.GetStatisticCAndPBySecondDepAsync(this.initData.searchNewTwoForm);
        }
    }
    @Watch('initData.searchThreeForm',{deep: true})  //整体数据
    async WatchSearchThree(newVal:any,oldValue:any){
        this.initData.searchNewThreeForm = Object.assign({},newVal);
        this.initData.searchNewThreeForm.beginYear = new Date(this.initData.searchNewThreeForm.beginYear).getFullYear();
        this.initData.searchNewThreeForm.endYear = new Date(this.initData.searchNewThreeForm.endYear).getFullYear();
        if(newVal.belongDepId != null){
            await this.GetStatisticCAndPByYearAsync(this.initData.searchNewThreeForm);
        }
    }
    @Watch('initData.searchFourForm',{deep: true})  //项目负责人
    async WatchSearchFour(newVal:any,oldValue:any){
        this.initData.searchNewFourForm = Object.assign({},newVal);
        this.initData.searchNewFourForm.beginYear = new Date(this.initData.searchNewFourForm.beginYear).getFullYear();
        this.initData.searchNewFourForm.endYear = new Date(this.initData.searchNewFourForm.endYear).getFullYear();
        if(newVal.belongDepId != null){
            await this.GetStatisticCAndPByProjectLeader(this.initData.searchNewFourForm);
        }
    }
    @Watch('initData.searchFiveForm',{deep: true})  //收款负责人
    async WatchSearchFive(newVal:any,oldValue:any){
        this.initData.searchNewFiveForm = Object.assign({},newVal);
        this.initData.searchNewFiveForm.beginYear = new Date(this.initData.searchNewFiveForm.beginYear).getFullYear();
        this.initData.searchNewFiveForm.endYear = new Date(this.initData.searchNewFiveForm.endYear).getFullYear();
        if(newVal.belongDepId != null){
            await this.GetStatisticCAndPByReceiptLeader(this.initData.searchNewFiveForm);
        }
    }
}
